export default __webpack_public_path__ + "static/media/woocommerce-negative.4d98ec9c.svg";